import React from "react";

export function Counter({ count, category = "listing", variant = "default" }) {
  if (count === null) return null;

  const label = `${count} ${category}${count !== 1 ? "s" : ""} found...`;

  if (variant === "lookbook") {
    return (
      <div className="lb-select-listings__count">
        <span>
          <strong>{count}</strong> {category}
          {count !== 1 ? "s" : ""} found.
        </span>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-start list-toolbar">
      <div className="align-self-center ms-4">
        <strong className="d-md-block">{label}</strong>
      </div>
    </div>
  );
}
